import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { TrainTypeEnum } from "../../../Orchestrator/Types/Enums/globalDefaultEnum";
import { TicketRadioType } from "../../../Orchestrator/Types/Index";


export class TicketTypeRadioChangeAction extends BaseAction<void, TicketRadioType> {

    override async run(): Promise<void | null> {
        try {
            const { outboundTrain, inboundTrain, priceClass, type, selectedTrainLegs } = this.params!;
            if (type === TrainTypeEnum.inbound) {
                updateRecoilState("selectedInboundTrainAtom", {
                    ...inboundTrain,
                    selectedPriceClass: priceClass,
                });
            } else {
                updateRecoilState("selectedOutboundTrainAtom", {
                    ...outboundTrain,
                    selectedPriceClass: priceClass,
                });
            }
            if ((type === TrainTypeEnum.outbound || type === TrainTypeEnum.inbound) && selectedTrainLegs) {
                if (selectedTrainLegs[type]) {
                    const updateLeg = [...selectedTrainLegs[type]].map(({ ...trainLeg }) => {
                        if (trainLeg.trainType === "train") {
                            trainLeg.trainClass = priceClass;
                        }
                        return trainLeg;
                    });
                    updateRecoilState("selectedTrainLegsAtom", {
                        ...selectedTrainLegs,
                        [type]: updateLeg,
                    });
                }
            }

            //Save the original train class selection
            updateRecoilState("originalTrainClassSelectionAtom", {
                [type]: priceClass,
            })

        } catch (error) {
            console.error("Error in TicketTypeRadioChangeAction:", error);
        }
    }
}

// Create a singleton instance
export const ticketTypeRadioChangeAction = new TicketTypeRadioChangeAction(); 